import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import UpgradeCellularDeviceBlockData from '../../../Models/Content/UpgradeCellularDeviceBlockData';
import UpgradeCellularDeviceMainComponent from './UpgradeCellularDeviceMainComponent';
import './UpgradeCellularDeviceStyle.scss';
export default class UpgradeCellularDeviceBlock extends EpiComponent<UpgradeCellularDeviceBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <UpgradeCellularDeviceMainComponent iContent={this.props.data} context={this.getContext()} />;
  }
}
